var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF002",
    transform: "translate(3.000000, 3.250000)",
    fill: "#285469",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625,7.3125 C14.6015625,8.953125 14.1328125,10.3945312 13.21875,11.6367188 L17.6835938,16.0664062 C17.8945312,16.3007812 18,16.5703125 18,16.875 C18,17.1796875 17.8945312,17.4492188 17.6835938,17.6835938 C17.4492188,17.8945312 17.1796875,18 16.875,18 C16.5703125,18 16.3007812,17.8945312 16.0664062,17.6835938 L11.6367188,13.21875 C10.3945312,14.1328125 8.953125,14.6015625 7.3125,14.625 C5.25,14.578125 3.52734375,13.8632812 2.14453125,12.4804688 C0.76171875,11.0976562 0.046875,9.375 0,7.3125 C0.046875,5.25 0.76171875,3.52734375 2.14453125,2.14453125 C3.52734375,0.76171875 5.25,0.046875 7.3125,0 C9.375,0.046875 11.0976562,0.76171875 12.4804688,2.14453125 C13.8632812,3.52734375 14.578125,5.25 14.625,7.3125 Z M7.3125,12.375 C8.7421875,12.328125 9.9375,11.8359375 10.8984375,10.8984375 L10.8984375,10.8984375 C11.8359375,9.9375 12.328125,8.7421875 12.375,7.3125 C12.328125,5.8828125 11.8359375,4.6875 10.8984375,3.7265625 C9.9375,2.7890625 8.7421875,2.296875 7.3125,2.25 C5.8828125,2.296875 4.6875,2.7890625 3.7265625,3.7265625 C2.7890625,4.6875 2.296875,5.8828125 2.25,7.3125 C2.296875,8.7421875 2.7890625,9.9375 3.7265625,10.8984375 C4.6875,11.8359375 5.8828125,12.328125 7.3125,12.375 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.3615548d1b2bb52f46a5d56bd8542bed.svg";
export { ForwardRef as ReactComponent };